import { createStorageValue } from '@interhyp/platform-storage';
import { createValue } from '@interhyp/platform-value';
import { z } from 'zod';
import { mortgageIntentNamespace } from '../namespaces';
/* repayment defines how the user entered his/her preferred repayment
 * if he/she selects 'desiredRepayment', the field desiredRepayment (in €) is non-optional (e.g. 2300)
 * if he/she selects 'amortisationInPercent', the field amortisationInPercent is non-optional (e.g. 1.5)
 * if he/she selects 'desiredTotalTimeInYears', the field desiredTotalTimeInYears is non-optional (e.g. 35)
 * if he/she selects 'fullRepayment', there is no further input required
 * the respective other values can be added optionally to be read by apps that don't offer the selected repayment input
 */
const repaymentSchema = z.discriminatedUnion('selectedRepaymentInput', [
    z.object({
        selectedRepaymentInput: z.literal('amortisationInPercent'),
        amortisationInPercent: z.number(),
        desiredRepayment: z.number().optional(),
        desiredTotalTimeInYears: z.number().optional(),
    }),
    z.object({
        selectedRepaymentInput: z.literal('desiredRepayment'),
        desiredRepayment: z.number(),
        amortisationInPercent: z.number().optional(),
        desiredTotalTimeInYears: z.number().optional(),
    }),
    z.object({
        selectedRepaymentInput: z.literal('desiredTotalTimeInYears'),
        desiredRepayment: z.number().optional(),
        amortisationInPercent: z.number().optional(),
        desiredTotalTimeInYears: z.number(),
    }),
    z.object({
        selectedRepaymentInput: z.literal('fullRepayment'),
        desiredRepayment: z.number().optional(),
        amortisationInPercent: z.number().optional(),
        desiredTotalTimeInYears: z.number().optional(),
    }),
]);
export const repaymentMemoryValue = createValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('repaymentMemory'),
    schema: repaymentSchema,
});
export const repaymentStorageValue = createStorageValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('repayment'),
    schema: repaymentSchema,
    type: 'local',
});
